import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

const Footer = () => {
	return (
		<footer id="footer" className="footer">
			<div className="footer-top">
				<div className="footer-top-inner">
					<div className="site-map">
						<ul className="site-map-list">
							<li>
								<Link to={NAV_PATH.INTRO}>서비스 소개</Link>
							</li>
							<li>
								<Link to={NAV_PATH.FUNCTION.MAIN}>특별한 기능</Link>
							</li>
							<li>
								<Link to={NAV_PATH.CONSULTING}>전문가 문의</Link>
							</li>
						</ul>
						<ul className="site-map-list">
							<li>
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>자주 묻는 질문</Link>
							</li>
							{/* <li>
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.EVENT}>이벤트</Link>
							</li> */}
							<li>
								<Link to={NAV_PATH.INQUIRY.SERVICE}>문의하기</Link>
							</li>
						</ul>
						<ul className="site-map-list">
							<li>
								<Link to={NAV_PATH.POLICY.PRIVACY}>개인정보 처리방침</Link>
							</li>
							<li>
								<Link to={NAV_PATH.POLICY.TERMS}>이용약관</Link>
							</li>
						</ul>
					</div>

					<div className="info">
						<ul className="info-list" tabIndex={0}>
							<li>COMPANY : (주)핑거 | CEO : 안인주</li>
							<li>EMAIL : stella@finger.co.kr</li>
							{/*<li>FAX : 02-000-0000</li>*/}
							<li>서울특별시 영등포구 여의대로 24, 43층 (여의도동, FKI 타워)</li>
							<li>통신판매신고번호 : 2009-서울영등포-0379</li>
							<li>사업자등록번호 : 120-86-15854</li>
							<li>고객센터 1811-6306 | 09:00~18:00 토,일,공휴일 휴무</li>
						</ul>
					</div>
				</div>
			</div>

			<div className="footer-bottom">
				<div className="footer-bottom-inner">
					<strong className="copyright">Copyright © 2025 FINGER INC.ALL RIGHTS RESERVED.</strong>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
